import Pusher from "pusher-js";
// const csrfToken = document
//     .querySelector('meta[name="csrf-token"]')
//     .getAttribute("content");
const userString = localStorage.getItem("token");
let token = "";
if (userString) {
    token = userString;
}
//// pusher from h....@canadasmm.com
// const pusher = new Pusher("29a5ef17b2f4d64aed32", {
//// pusher from m...h....a@gmail.com
const pusher = new Pusher("e9c7b0122bbd44854f44", {
    cluster: "ap2",
    forceTLS: true,
    authEndpoint: "http://localhost:8000/api/admin/broadcasting/auth",
    auth: {
        headers: {
            Authorization: `Bearer ${token}`,
            "X-Requested-With": "XMLHttpRequest",
        },
    },
});
export default pusher;


// import Pusher from 'pusher-js';
//
// // Pusher.logToConsole = true;
// const pusher = new Pusher('29a5ef17b2f4d64aed32', {
//     cluster: 'ap2',
//     forceTLS: true,
// });
// export default pusher;